// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9-w_D","column":"styles_column__1IgIk"};